// Tiny observable for the pending "Approve call from Ellie?" sheet. The push-tap
// handler (RootNavigator) sets the pending call when a voice_call_approval push
// is opened; VoiceCallApprovalSheet — mounted once, globally — subscribes and
// presents it. Kept out of Redux: it's transient UI with a single consumer.
export type PendingVoiceApproval = {
  callId: string;
  phone?: string;
  planName?: string;
};

let _pending: PendingVoiceApproval | null = null;
const listeners = new Set<(p: PendingVoiceApproval | null) => void>();

export function showVoiceApproval(p: PendingVoiceApproval): void {
  _pending = p;
  listeners.forEach((l) => l(_pending));
}

export function clearVoiceApproval(): void {
  _pending = null;
  listeners.forEach((l) => l(null));
}

export function getVoiceApproval(): PendingVoiceApproval | null {
  return _pending;
}

export function subscribeVoiceApproval(l: (p: PendingVoiceApproval | null) => void): () => void {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}
